import React from 'react';
import MercuryLogo from './MercuryLogo';

export default function Footer() {
  return (
    <footer className="relative bg-white border-t border-[#e8e4d8] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <MercuryLogo />
            <p className="mt-5 text-[#4a4f4c] text-sm max-w-sm leading-relaxed">
              Trusted Home Leads is a marketing agency built exclusively for local service contractors. Real leads. Real jobs. No fluff.
            </p>
          </div>
          <div>
            <div className="text-[#0b0f0d] font-display font-semibold mb-4 text-sm uppercase tracking-widest">Company</div>
            <ul className="space-y-2.5 text-sm text-[#4a4f4c]">
              <li><a href="#services" className="hover:text-[#0b0f0d]">Services</a></li>
              <li><a href="#who-we-serve" className="hover:text-[#0b0f0d]">Who We Serve</a></li>
              <li><a href="#how-it-works" className="hover:text-[#0b0f0d]">Our Process</a></li>
              <li><a href="#testimonials" className="hover:text-[#0b0f0d]">Case Studies</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[#0b0f0d] font-display font-semibold mb-4 text-sm uppercase tracking-widest">Trades</div>
            <ul className="space-y-2.5 text-sm text-[#4a4f4c]">
              <li>Painters</li>
              <li>Roofers</li>
              <li>HVAC</li>
              <li>Plumbers</li>
              <li>Electricians</li>
              <li>Landscapers</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-[#e8e4d8] text-xs text-[#6b6f6c] text-center md:text-left">
          © 2025 Trusted Home Leads. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
